import { useState, useEffect } from 'react';

import { useAuth } from "../../app/context";

const Footer = () =>{
  const [currentYear, setCurrentYear] = useState('');
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  let { contact, translations } = useAuth();  
  return(
    <footer id="contact" className="block-full bg-highlight-3 px-16 sm:px-24 lg:px-32 xl:px-0 pt-40 pb-24 lg:pt-96 lg:pb-32 text-center">
      <div className="block-full mx-auto max-w-1200">
        <div className="block-full color-white font-inter fw-700 fs-30 lh-36 md:fs-36 md:lh-40 lg:fs-40 lg:lh-48 mb-8 lg:mb-12">{translations.contact.title}</div>
        <p className="block-full mb-24 lg:mb-40 color-gray fs-16 lh-24 font-inter">
          {contact.availability}
        </p>
        <div className="grid-cols-1 grid-cols-md-2 gap-24 md:gap-32 ">
          <div className="block-full p-24 br-12" style={{background:'rgba(255,255,255,0.1)',backdropFilter: "blur(10px)"}}>
            <div className="block-full fs-32 lh-32 mb-16">📧</div>
            <div className="block-full mb-8 fw 600 font-inter fs-16 color-white">{translations.contact.tabs[0]}</div>
            <div className="block-full fs-16 lh-20 font-inter color-gray">{contact.email}</div>
          </div>
          <div className="block-full p-24 br-12" style={{background:'rgba(255,255,255,0.1)',backdropFilter: "blur(10px)"}}>
            <div className="block-full fs-32 lh-32 mb-16">📍</div>
            <div className="block-full mb-8 font-inter fw 600 fs-16 color-white">{translations.contact.tabs[1]}</div>
            <div className="block-full fs-16 lh-20 font-inter color-gray">{contact.location}</div>
          </div>
        </div>
        <div className="block-full pt-24 mt-24 lg:mt-48 bw-0 bw-t-1 bs-solid bc-gray">
          <div className="block-full fs-12 lh-16 color-gray px-16">&copy; {currentYear} {translations.contact.texts[1]}</div>
          <div className="block-full fs-12 lh-16 mt-8 md:mt-16 color-gray px-16">
            {translations.contact.texts[1]}
          </div>
        </div>
      </div>
    </footer>  
  )
}

export default Footer;
